module.exports = __webpack_public_path__ + "static/media/ServiceBET.28f3393d.jpg";